<template>
  <div>
    <img style="width:100%" src="@/assets/joinUs.png" />
    <div class="container padding-tb-sm">
      <el-row type="flex" justify="space-between">
        <el-col :span="9">
          <p class="text-bold text-xxl1">入会条件</p>
          <p class="border"></p>
          <p class="text-lg">
            单位会员：在本省登记，具备单独法人资格，开展物联网服务业务、提供物联网技术服务的电信企业、通信服务企业、互联网企业；从事物联网技术研究的研发机构或开展物联网技术教学、研究工作的高等院校。
          </p>
        </el-col>
        <el-col :span="9" class="margin-left">
          <p class="text-bold text-xxl1">会员收费标准</p>
          <p class="border"></p>
          <table cellspacing="0" style="border-color: #ccc">
            <tr height="40px">
              <th width="400px">类型</th>
              <th width="400px">收费标准（元/年）</th>
            </tr>
            <tr>
              <td>普通会员</td>
              <td>2000</td>
            </tr>
            <tr>
              <td>理事会员</td>
              <td>5000</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </div>
    <div style="background:#F9F9F9" class="padding-tb-sm">
      <p class="text-bold text-xxl1 text-center ">入会流程</p>
      <div class="progress">
        <p class="p-left"> <span>一、意向入会单位下载并填写<br>
            《会员申请表<br>
            <el-button icon="el-icon-download" class="downLoad"><a href="./江苏省物联网服务协会入会申请表.docx">点击下载会员申请</a></el-button>
          </span>
          <span class="circle" style="margin-left:35px"></span></p>
        <p class="line" style="height:117px; margin-top: -101px;"></p>
        <p class="p-right"> <span class="circle"> </span>
          <span>
            二、将电子版发至江苏省物联网服务<br>
            协会电子邮箱：<br>
            jsiotservice@163.com</span>
        </p>
        <p class="line" style="height:107px; margin-top: -92px;"></p>
        <p class="p-left"><span>三、秘书处审核并与申请单位<br>取得联系；</span> <span class="circle"></span></p>
        <p class="line" style="height:78px; margin-top: -62px;"></p>
        <p class="p-right"><span class="circle"></span><span>四、审核通过，完善相关资料，协会备案；</span></p>
        <p class="line" style="height:78px; margin-top: -62px;"></p>
        <p class="p-left"><span>五、颁发会员证书。</span><span class="circle" style="margin-left:35px"></span> </p>
      </div>
    </div>
    <div class="container">
      <p class="text-bold text-xxl1 text-center ">联系我们</p>
      <div class="flex justify-between">
        <p><span class="text-xl lh-sm">协会地址</span><br><span class="primary margin-top lh-df"><i
              class="el-icon-location-information border-circle"></i>
            南京市秦淮区悦动新门西9栋101</span></p>
        <p><span class="text-xl">联系电话</span><br><span class="primary  text-lg lh-df"><i
              class="el-icon-mobile-phone border-circle"></i>
            17558862682 赵老师</span>
        </p>
        <p><span class="text-xl">电子邮箱</span><br><span class="primary  text-lg lh-df"><i
              class="el-icon-message border-circle"></i>
            jsiotservice@163.com</span>
        </p>
      </div>
      <img src="@/assets/map.png" alt="" class="margin-bottom-lg">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'JoinUs',
    data() {
      return {
        column: [{
            title: '类型',
            key: 'type'
          },
          {
            title: '收费标准（元/年）',
            key: 'charge'
          }
        ],
        data: [{
            type: '普通会员',
            charge: '2000'
          },
          {
            type: '理事会员',
            charge: '5000'
          }
        ]
      }
    },
    computed: {},
    created() {
      this.init()
    },
    // 方法集合
    methods: {
      init() {}
    }
  }
</script>
<style scoped>
  .circle {
    border-radius: 50%;
    background: #AA0000;
    width: 15px !important;
    height: 15px;
    display: inline-block;
    margin-left: 30px;
    margin-right: 30px;
  }

  .progress {
    margin: 0 auto;
    width: 1200px;
  }

  p {
    color: #333333;
    line-height: 30px;
  }

  .progress p>span {
    width: 260px;
    display: inline-block;
    vertical-align: top;
    margin-top: 15px;
  }

  .p-left {
    margin-left: 300px;
  }

  .p-right {
    margin-left: 565px;
  }

  .border {
    width: 30px;
    height: 3px;
    background: #AA0000;
    margin-top: -10px;
  }

  .line {
    background: #888888;
    width: 1px;
    position: absolute;
    /* top: 886px; */
    margin-left: 602px;
  }

  .border-circle {
    border-radius: 50%;
    border: 1px solid #AA0000;
    padding: 5px;
  }

  table {
    border-collapse: collapse;
    color: #333333;
    font-size: 13px;
  }

  table,
  table tr th,
  table tr td {
    border: 1px solid #888888;
  }

  .downLoad {
    color: #fff !important;
    background: #AA0000;
  }

  a {
    color: #fff !important;
    text-decoration: none
  }

  tr>td {
    height: 40px;
    padding-left: 20px;
  }
</style>